document.addEventListener("DOMContentLoaded", () => {
  const moveJudgeMeAverage = () => {
    document.querySelectorAll(".jdgm-rev-widg__summary").forEach((summary) => {
      const average = summary.querySelector(".jdgm-rev-widg__summary-average");
      const stars = summary.querySelector(".jdgm-rev-widg__summary-stars");

      if (!average || !stars) return;

      summary.prepend(average);
    });
  };

  moveJudgeMeAverage();

  setTimeout(moveJudgeMeAverage, 500);
  setTimeout(moveJudgeMeAverage, 1500);
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const title = document.querySelector(".jdgm-rev-widg__title");
    if (!title) return;

    if (window.innerWidth <= 767) {
      title.innerHTML = title.textContent
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/\s*\n\s*/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    } else {
      title.innerHTML = title.textContent.replace(/<br\s*\/?>/gi, "<br>");
    }
  }, 1500);
});

// document.addEventListener("DOMContentLoaded", () => {
//   const moveVerifiedBadges = () => {
//     document.querySelectorAll(".jdgm-rev").forEach((review) => {
//       const author = review.querySelector(".jdgm-rev__author");
//       const badge = review.querySelector(".jdgm-rev__buyer-badge-wrapper");

//       if (!author || !badge || badge.dataset.moved === "true") return;

//       author.insertAdjacentElement("afterend", badge);
//       badge.dataset.moved = "true";
//     });
//   };

//   moveVerifiedBadges();

//   const observer = new MutationObserver(moveVerifiedBadges);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });
// });
document.addEventListener("DOMContentLoaded", () => {
  const moveDates = () => {
    document.querySelectorAll(".jdgm-rev").forEach((review) => {
      const date = review.querySelector(".jdgm-rev__timestamp");
      const title = review.querySelector(".jdgm-rev__title");

      if (!date || !title || date.dataset.moved === "true") return;

      title.insertAdjacentElement("afterend", date);
      date.dataset.moved = "true";
    });
  };

  moveDates();

  new MutationObserver(moveDates).observe(document.body, {
    childList: true,
    subtree: true,
  });
});
